import { ShieldCheck, ShieldAlert, ShieldQuestion } from "lucide-react";
import { Badge } from "./ui/badge";

const MAP = {
  verified: { cls: "bg-emerald-500/20 text-emerald-300 border-emerald-500/30", Icon: ShieldCheck, label: "VIN verified · matches listing" },
  mismatch: { cls: "bg-amber-500/20 text-amber-300 border-amber-500/30", Icon: ShieldAlert, label: "VIN decoded · details differ" },
  invalid: { cls: "bg-red-500/20 text-red-300 border-red-500/30", Icon: ShieldAlert, label: "Invalid VIN" },
  unrecognized: { cls: "bg-slate-700 text-slate-300 border-slate-600", Icon: ShieldQuestion, label: "VIN not recognized" },
  unavailable: { cls: "bg-slate-700 text-slate-300 border-slate-600", Icon: ShieldQuestion, label: "VIN check unavailable" },
};

export default function VinBadge({ report, compact = false }) {
  if (!report) return compact ? null : <Badge data-testid="vin-badge-none" className="bg-slate-800 text-slate-400 border border-slate-700 text-[10px] uppercase">No VIN provided</Badge>;
  const m = MAP[report.status] || MAP.unavailable;
  return (
    <Badge data-testid={`vin-badge-${report.status}`} className={`border backdrop-blur-md font-mono text-[10px] tracking-wide ${m.cls}`}>
      <m.Icon className="w-3 h-3 mr-1" />{compact ? (report.status === "verified" ? "VIN ✓" : "VIN") : m.label}
    </Badge>
  );
}
